module.exports = __webpack_public_path__ + "static/img/third18.f6a40762.png";